import interactionParserUtils from './InteractionParserUtils';
import xmlDomUtils from '../../../utils/XmlDomUtils';
import utilService from '../../../../services/UtilService';

const codeCompilerParser = {
    parseCodeCompilerSampleValues(sampleNode) {
        const sampleValues = [];
        for (const sampleChildNode of Array.from(sampleNode.childNodes)) {
            if (sampleChildNode.nodeName === 'inspera:value' && sampleChildNode.childNodes.length > 0) {
                sampleValues.push(sampleChildNode.childNodes[0].nodeValue);
            }
        }
        return sampleValues;
    },

    mergeCodeCompilerSampleValues(sampleInputValues, sampleOutputValues) {
        const codeCompilerSamples = [];
        sampleInputValues.forEach((value, index) => {
            codeCompilerSamples.push({
                expectedInput: value,
                expectedOutput: sampleOutputValues[index],
            });
        });
        return codeCompilerSamples;
    },

    parseCodeCompilerSamples(interaction) {
        const sampleInput = interaction.getElementsByTagName('inspera:compilerSampleInput')[0];
        const sampleOutput = interaction.getElementsByTagName('inspera:compilerSampleOutput')[0];
        const sampleInputValues = this.parseCodeCompilerSampleValues(sampleInput);
        const sampleOutputValues = this.parseCodeCompilerSampleValues(sampleOutput);

        return this.mergeCodeCompilerSampleValues(sampleInputValues, sampleOutputValues);
    },

    parse(interaction, language, defaultLanguage, responseDeclarations) {
        const attributes = xmlDomUtils.getAttributes(interaction);
        const { autoExpand, autosave, expectedLength } = attributes;
        let codeCompilerSamples;
        const codeMode = attributes['inspera:codeMode'] || '';
        const showGutter = attributes['inspera:showGutter'] === 'true';
        const variant = attributes['inspera:variant'] || '';
        const prompt = interactionParserUtils.getPrompt(interaction, language, defaultLanguage);

        if (variant === 'code-compiler') {
            codeCompilerSamples = this.parseCodeCompilerSamples(interaction);
        }

        const extraResponseDeclarations = responseDeclarations.filter(eR =>
            eR.identifier === 'RESPONSE_compiler_response'
        );

        return {
            autoExpand: autoExpand !== 'false',
            autoSaveInterval: utilService.getIntOr(autosave, 0),
            codeMode,
            codeCompilerSamples,
            expectedLength: utilService.getIntOr(expectedLength, 0),
            extraResponseDeclarations,
            prompt,
            showGutter,
            variant,
        };
    },
};

export default codeCompilerParser;
